import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import { useLocation } from "react-router-dom";

import Box from "@mui/material/Box";
import {
  Button,
  Checkbox,
  CircularProgress,
  IconButton,
  Typography,
} from "@mui/material";

import { AppDispatch, RootState } from "../../../redux/store";
import { setResponseValue } from "../../../redux/features/api-response/api-response";
import {
  GetAllProviders,
  GetProviderTypes,
} from "../../../redux/features/providers-main/provider-list-slice";
import { GetAllClientData } from "../../../redux/features/client-main/client-list-slice";
// import { GetScheduleList } from "../../../redux/features/schedules-main/schedule-list-slice";
import {
  getPlanById,
  RefreshUtilizationData,
} from "../../../redux/features/plannings/planning-slice";

import PlannerClientList from "../planning-Lists/PlannerClientList";
import PlannerProviderList from "../planning-Lists/PlannerProviderList";
import DataTable from "../data-View/DataTable";
import PlanningCalenderNew from "../manualBooking-Calender/PlanningCalenderNew";
import PlanningMap from "../planningMap/PlanningMap";

import { ClientForms, utilizationdata } from "../../../types/client";
import { ProviderForms } from "../../../types/provider";
import { IPlanDetail, PlannerFilter } from "../../../types/planning";
// import { filterPlanners } from "../../../helpers/planner-filter-helper/planners-filter-helper";
import { defaultPlanningFilter } from "../../../constants/planning";

// import "react-splitter-layout/lib/index.css";
import "../../maps/Map-Details/mapDetails.scss";
import { setPlanningFilterValues } from "../../../redux/features/plannings/planning-filter-slice";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useFilteredData } from "../../../hooks/useFilteredData";
import LoopIcon from "@mui/icons-material/Loop";
export interface IPlanninglistSelect {
  id: string;
  group: boolean;
  single: boolean;
  clientGroup?: boolean;
}

// Add proper typing for the cache
interface DataCache {
  clients: any | null;
  providers: any | null;
  providerTypes: any | null;
}

interface IPlanDetails {
  setchangedList: React.Dispatch<React.SetStateAction<boolean>>;
  pendingSchedulesCount: number;
}
const PlanningsDetails: React.FC<IPlanDetails> = ({ setchangedList, pendingSchedulesCount }) => {
  // #region variable region
  //dispatch defined
  const dispatch: AppDispatch = useDispatch<AppDispatch>();
  //binding action creators
  const dispatchAction = bindActionCreators(
    {
      // GetScheduleList,
      GetAllClientData,
      GetAllProviders,
      setResponseValue,
      getPlanById,
      GetProviderTypes,
    },
    dispatch
  );
  //same dispatch ref between multiple re-renders
  // const dispatchActionRef = useRef(dispatchAction);

  const currentPlan = useSelector<RootState, IPlanDetail>(
    (state) => state.planSlice.currentPlan
  );

  const clientData = useSelector<RootState, ClientForms[]>(
    (state) => state.clientListSlice.listData
  );

  //stores client data according utlization date range
  const UtilizationData = useSelector<RootState, utilizationdata>(
    (state) => state.clientListSlice.utilizationListData
  );
  // handle change in client data
  const isDataUpdate = useSelector<RootState, boolean>(
    (state) => state.clientListSlice.dataUpdate
  );
  //Variable stores filtervalues
  const filterValues = useSelector<RootState, PlannerFilter>(
    (state) => state.planningFilterSlice.PlanningFilter
  );

  //Variable stores searchValues
  const searchValue = useSelector<RootState, string>(
    (state) => state.activeStep.searchValue
  );

  //Variable stores refresh utilization loading
  const refreshLoading = useSelector<RootState, boolean>(
    (state) => state.planSlice.refreshUtlizationInProgress
  );

  //used to store path location
  const { pathname } = useLocation();

  //Provider Data fetching
  const providerData = useSelector<RootState, ProviderForms[]>(
    (state) => state.providerListSlice.listData
  );

  //selected tab to display proper pages
  const [selectedTab, setSelectedTab] = useState<string>("Clients");

  //selected tab to display calendera and map
  const [selectedApplicationTab, setSelectedApplicationTabs] =
    useState<string>("Calendar");

  //change to handle booking delete and edit
  const [bookingChange, setBookingChange] = useState<boolean>(false);

  /*
    manage different types of lists
    - selectedClients & selectedProviderLists = Filtered + Checked
    - filteredClientList & filteredProviderList = Filtered
    - selectedClientIds & selectedProviderIds = for DataTable & track single id list
    - filteredIds = Filtered ids for DataTable
    // - calendarClientList & calendarProviderList = for Calendar (deprecate this!)
  */
  const [selectedClients, setSelectedClients] = useState<ClientForms[]>([]);
  const [selectedProviders, setSelectedProviders] = useState<ProviderForms[]>(
    []
  );

  const [selectedClientIds, setSelectedClientIds] = useState<
    IPlanninglistSelect[]
  >([]);
  const [selectedProviderIds, setSelectedProviderIds] = useState<
    IPlanninglistSelect[]
  >([]);

  //track filter applied status
  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);

  //track check status
  const [isAllSelected, setIsAllSelected] = useState<{
    client: boolean;
    provider: boolean;
  }>({
    client: false,
    provider: false,
  });
  //handle drawer
  const [drawerOpen, setDrawerOpen] = useState(true);

  // Add new loading state
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [loadingStates, setLoadingStates] = useState({
    clients: false,
    providers: false,
    schedules: false,
    providerTypes: false,
    plan: false,
  });

  // Add cache state
  const [dataCache, setDataCache] = useState<DataCache>({
    clients: null,
    providers: null,
    providerTypes: null,
  });

  // Add this near other state declarations
  const [loadingMessage, setLoadingMessage] = useState(
    "Loading calendar data..."
  );

  // Replace the existing filtering logic with useFilteredData
  const {
    filteredClients: filteredClientList,
    filteredProviders: filteredProviderList,
    filteredIds,
  } = useFilteredData({
    clientData,
    providerData,
    filterValues,
    searchValue,
    isLoading: isDataLoading,
    isDataUpdate,
    utilizationData: UtilizationData,
  });
  // console.log("filteredClientList, filteredProviderList, filteredIds:", filteredClientList, filteredProviderList, filteredIds);

  // Add a loading tracker ref to prevent duplicate initialization
  const isInitialLoadStarted = useRef(false);

  // #endregion

  // #region methods region

  //When user clicks "Add to Calendar" button in DataTable, this method is called
  const addIntoCalendar = (cmd: any) => {
    let filterProvider: any[] = [];
    let filterClient: any[] = [];
    cmd.forEach((cmd: any) => {
      if (cmd.type === "Employee") {
        // SetProvider
        if (isDataUpdate) {
          filterProvider = [
            ...filterProvider,
            ...UtilizationData.Provider.filter((provider) => {
              return provider.employmentDetails.id === cmd.id;
            }),
          ];
        } else {
          filterProvider = [
            ...filterProvider,
            ...providerData.filter((provider) => {
              return provider.employmentDetails.id === cmd.id;
            }),
          ];
        }
      } else if (cmd.type === "Client") {
        filterClient = [
          ...filterClient,
          ...clientData.filter((client) => {
            return client.clientBasicDetails.id === cmd.id;
          }),
        ];
      }
    });

    //updated calendar list
    setSelectedProviders(filterProvider);
    setSelectedClients(filterClient);
    setSelectedApplicationTabs("Calendar");
  };

  const handleSelectAll = () => {
    //mark plan changed
    setchangedList(true);

    //1. for Clients Tab
    if (selectedTab === "Clients" && filteredClientList.length > 0) {
      //1a. if all clients are already selected
      if (isAllSelected.client === true) {
        //cleanup client selection
        setSelectedClientIds([]);
        setSelectedClients([]);
        setIsAllSelected({ ...isAllSelected, client: false });

        //for client's supervior + provider teams, also cleanup
        if (selectedProviders.length > 0) {
          let data = selectedProviders.filter((item) =>
            selectedProviderIds.some(
              (ele) =>
                ele.id === item.employmentDetails.id &&
                (ele.group || ele.single)
            )
          );
          setSelectedProviderIds(
            selectedProviderIds.map((item) => {
              return {
                ...item,
                clientGroup: false,
              };
            })
          );
          setSelectedProviders(data);
        }
        return;
      }

      //1b. if all clients are not selected, now select them
      setIsAllSelected({ ...isAllSelected, client: true });

      //get all selected clients
      let newClientSelection: any[] = [];
      newClientSelection = selectedClientIds.map((client) => {
        const matchedItem = filteredClientList.find(
          (item) => item.clientBasicDetails.id === client.id
        );
        if (matchedItem) {
          return {
            ...client,
            single: true,
            group: matchedItem.clientBasicDetails.supervisorId
              ? true
              : client.group,
          };
        }
        return client;
      });
      // console.log("newClientSelection, selectedClientIds:", newClientSelection, selectedClientIds);

      filteredClientList.forEach((item) => {
        if (
          !selectedClientIds.some(
            (client) => client.id === item.clientBasicDetails.id
          )
        ) {
          newClientSelection.push({
            id: item.clientBasicDetails.id,
            single: true,
            group: !!item.clientBasicDetails.supervisorId,
          });
        }
      });
      setSelectedClients(filteredClientList);
      setSelectedClientIds(newClientSelection);

      const clientSupervisor = filteredClientList
        .filter((item) => item.clientBasicDetails?.supervisorId)
        .map((ele) => ele.clientBasicDetails.supervisorId);

      let providersId: string[] = [];
      const [data] = filteredProviderList
        .filter((item) => clientSupervisor.includes(item.employmentDetails.id))
        .map((item) => item.employmentDetails.providerList);

      if (data?.length > 0 && clientSupervisor?.length > 0) {
        providersId = Array.from(new Set([...data, ...clientSupervisor]));
      }
      let providers: ProviderForms[] = [];
      filteredProviderList.forEach((item) => {
        if (
          providersId.includes(item.employmentDetails.id) &&
          item.employmentDetails.isSupervisor
        ) {
          providers.push(item);
        }
      });
      setSelectedProviders(providers);
      return;
    }

    //2. for Employees Tab
    if (selectedTab === "Employees" && filteredProviderList.length > 0) {
      //2a. if all providers are already selected
      if (isAllSelected.provider === true) {
        setIsAllSelected({ ...isAllSelected, provider: false });
        setSelectedProviders([]);
        setSelectedProviderIds([]);
        return;
      }
      //2b. if all providers are not selected, now select them
      setIsAllSelected({ ...isAllSelected, provider: true });

      const uniqueProviders = Array.from(
        new Map(
          filteredProviderList.map((item) => [item.employmentDetails.id, item])
        ).values()
      );

      setSelectedProviders(uniqueProviders);

      const newProviderSelection = uniqueProviders.map((item) => ({
        id: item.employmentDetails.id,
        single: true,
        group:
          item.employmentDetails.isSupervisor &&
          item.employmentDetails.providerList.length > 0,
      }));

      setSelectedProviderIds(newProviderSelection);
    }
  };

  // #endregion

  // #region useEffect region

  const loadInitialData = useCallback(async () => {
    // Check if initial load has already started
    if (isInitialLoadStarted.current || isDataLoading) {
      // console.log('🔄 Load already in progress, skipping...');
      return;
    }

    try {
      isInitialLoadStarted.current = true;
      setLoadingMessage("🚀 Starting data load process...");
      setIsDataLoading(true);

      // First load critical data (clients and providers)
      const loadData = async (key: keyof DataCache, action: any) => {
        if (dataCache[key]) {
          // console.log(`📦 Using cached data for ${key}`);
          setLoadingStates((prev) => ({ ...prev, [key]: false }));
          return;
        }

        setLoadingStates((prev) => ({ ...prev, [key]: true }));
        setLoadingMessage((prev) => {
          const lines = prev.split("\n").filter((line) => !line.includes(key));
          return [...lines, `⏳ Loading ${key}...`].join("\n");
        });

        const startTime = performance.now();
        try {
          await new Promise((resolve, reject) => {
            const timeout = setTimeout(() => {
              setLoadingMessage((prev) => {
                const lines = prev
                  .split("\n")
                  .filter((line) => !line.includes(key));
                return [...lines, `⚠️ ${key} load timeout`].join("\n");
              });
              reject(new Error(`${key} load timeout`));
            }, 60000);

            dispatch(action)
              .then((result: any) => {
                clearTimeout(timeout);
                const endTime = performance.now();
                setDataCache((prev) => ({ ...prev, [key]: result }));
                setLoadingMessage((prev) => {
                  const lines = prev
                    .split("\n")
                    .filter((line) => !line.includes(key));
                  return [
                    ...lines,
                    `✅ ${key} loaded in ${(
                      (endTime - startTime) /
                      1000
                    ).toFixed(1)}s`,
                  ].join("\n");
                });
                resolve(result);
              })
              .catch((error: any) => {
                clearTimeout(timeout);
                reject(error);
              });
          });
        } catch (error) {
          console.error(`Error loading ${key}:`, error);
          setLoadingMessage((prev) => {
            const lines = prev
              .split("\n")
              .filter((line) => !line.includes(key));
            return [...lines, `❌ Failed to load ${key}`].join("\n");
          });
          dispatchAction.setResponseValue({
            message: `Error loading ${key}`,
            type: "warning",
          });
        } finally {
          setLoadingStates((prev) => ({ ...prev, [key]: false }));
        }
      };

      const loadResults = await Promise.allSettled([
        loadData("clients", GetAllClientData("planning")),
        loadData("providers", GetAllProviders("planning")),
        loadData("providerTypes", GetProviderTypes()),

        // GetPlanById will be called in PlanningHeading Component!!
        // currentPlan?.plan?.id ?
        //   dispatch(getPlanById({ Id: currentPlan.plan.id })) :
        //   Promise.resolve()
      ]);

      setLoadingMessage((prev) => `${prev}\n🎉 All data loaded successfully!`);

      // Add 1 second delay before completing
      await new Promise((resolve) => setTimeout(resolve, 1000));

      setLoadingMessage("✅ Loading complete - Ready to plan!");
    } catch (error) {
      console.error("❌ Fatal error in loadInitialData:", error);
      dispatchAction.setResponseValue({
        message: "Error loading data",
        type: "error",
      });
    } finally {
      setIsDataLoading(false);
    }
  }, [isDataLoading, dispatch, dispatchAction, dataCache]);

  /*
  // Add a debug effect to monitor cache updates
  useEffect(() => {
    console.log('📦 Cache updated:', 
      Object.entries(dataCache)
        .map(([key, value]) => `${key}: ${value ? '✅' : '❌'}`)
    );
  }, [dataCache]);
  */

  // Modify the initialization effect
  useEffect(() => {
    if (!currentPlan?.plan?.id) {
      // console.log("❌ No plan ID available yet");
      return;
    }

    loadInitialData();

    // Cleanup function to reset the initialization flag when component unmounts
    return () => {
      isInitialLoadStarted.current = false;
    };
  }, [currentPlan?.plan?.id]); // Only depend on plan ID

  function initializeSelections() {
    // Skip if data isn't loaded or no plan
    if (isDataLoading || !currentPlan?.plan) return;

    // Helper to map IDs to full objects and create selection objects
    const mapSelectionsFromData = (
      planIds: string[] = [],
      currentSelections: any[] = [],
      dataSource: any[],
      idPath: "clientBasicDetails.id" | "employmentDetails.id"
    ) => {
      // Use either existing selections or plan data
      const sourceIds =
        currentSelections.length > 0
          ? currentSelections.map((item) =>
              idPath === "clientBasicDetails.id"
                ? item.clientBasicDetails.id
                : item.employmentDetails.id
            )
          : planIds;

      // Map to full objects
      const selectedObjects = sourceIds
        .map((id) =>
          dataSource.find((item) =>
            idPath === "clientBasicDetails.id"
              ? item.clientBasicDetails.id === id
              : item.employmentDetails.id === id
          )
        )
        .filter(Boolean);

      // Create selection state objects
      const selectionIds = selectedObjects.map((item) => ({
        id:
          idPath === "clientBasicDetails.id"
            ? item.clientBasicDetails.id
            : item.employmentDetails.id,
        group: false,
        single: true,
        ...(idPath === "employmentDetails.id" && { clientGroup: false }),
      }));

      return { selectedObjects, selectionIds };
    };

    const { selectedObjects: clients, selectionIds: clientIds } =
      mapSelectionsFromData(
        currentPlan.plan.clients,
        selectedClients,
        clientData,
        "clientBasicDetails.id"
      );

    const { selectedObjects: providers, selectionIds: providerIds } =
      mapSelectionsFromData(
        currentPlan.plan.providers,
        selectedProviders,
        providerData,
        "employmentDetails.id"
      );

    setSelectedClients(clients);
    setSelectedProviders(providers);
    setSelectedClientIds(clientIds);
    setSelectedProviderIds(providerIds);
  }

  useEffect(() => {
    initializeSelections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pathname,
    clientData,
    providerData,
    currentPlan?.plan?.id,
    isDataLoading,
  ]);

  useEffect(() => {
    const hasActiveFilters = Object.entries(filterValues).some(
      ([key, value]) => {
        const defaultValue = defaultPlanningFilter[key as keyof PlannerFilter];
        return JSON.stringify(value) !== JSON.stringify(defaultValue);
      }
    );

    setIsFilterApplied(hasActiveFilters && !searchValue);
  }, [filterValues, searchValue]);

  useEffect(() => {
    if (isDataLoading || !currentPlan?.plan?.appliedFilters) return;

    dispatch(setPlanningFilterValues(currentPlan.plan.appliedFilters));
  }, [currentPlan.plan?.appliedFilters, isDataLoading, dispatch]);
  // Also check the initialization in useEffect
  // useEffect(() => {
  //   if (currentPlan?.plan?.providers) {
  //     // Ensure unique providers when initializing from plan
  //     const uniqueProviders = Array.from(
  //       new Map(
  //         providerData
  //           .filter(provider =>
  //             currentPlan.plan.providers.includes(provider.employmentDetails.id)
  //           )
  //           .map(item => [item.employmentDetails.id, item])
  //       ).values()
  //     );

  //     setSelectedProviders(uniqueProviders);

  //     const providerIds = uniqueProviders.map(provider => ({
  //       id: provider.employmentDetails.id,
  //       group: false,
  //       single: true,
  //       clientGroup: false
  //     }));

  //     setSelectedProviderIds(providerIds);
  //   }
  // }, [currentPlan?.plan?.providers, providerData]);

  // Also check where providers are added from client selection
  // const handleClientSelection = (client: ClientForms) => {
  //   if (client.clientBasicDetails?.supervisorId) {
  //     const supervisor = providerData.find(
  //       provider => provider.employmentDetails.id === client.clientBasicDetails.supervisorId
  //     );

  //     if (supervisor) {
  //       // Ensure we don't add duplicate supervisor
  //       setSelectedProviders(prev => {
  //         const exists = prev.some(p =>
  //           p.employmentDetails.id === supervisor.employmentDetails.id
  //         );
  //         return exists ? prev : [...prev, supervisor];
  //       });
  //     }
  //   }
  // };

  // console.log("selectedClients:", selectedClients?.length);
  // console.log("filteredClientList:", filteredClientList?.length);

  // #endregion
  return (
    <React.Fragment>
      <Box sx={{ display: "flex", width: "100%" }} className="planning-details">
        <Box
          className="planningList"
          sx={{
            width: drawerOpen ? "10%" : "5px",
            minWidth: drawerOpen ? "390px" : "5px",
          }}
        >
          {drawerOpen && (
            <Box px={"0px"}>
              <Box className="listHeader">
                <ul className="innerTabs">
                  <li className="innerTabs__item">
                    <button
                      onClick={() => setSelectedTab("Clients")}
                      className={selectedTab === "Clients" ? "active" : ""}
                    >
                      Clients&nbsp;
                      <span style={{ fontSize: 14 }}>
                        ({filteredClientList.length})
                      </span>
                    </button>
                  </li>
                  <li className="innerTabs__item">
                    <button
                      onClick={() => setSelectedTab("Employees")}
                      className={selectedTab === "Employees" ? "active" : ""}
                    >
                      Employees&nbsp;
                      <span style={{ fontSize: 14 }}>
                        ({filteredProviderList.length})
                      </span>
                    </button>
                  </li>
                </ul>
                <div>
                  <IconButton
                    onClick={() => dispatch(RefreshUtilizationData({ startDate: (filterValues?.startDate || "") , endDate: (filterValues?.endDate || "")}))} 
                  >
                    {refreshLoading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <LoopIcon />
                    )}
                  </IconButton>
                  <Checkbox
                    onClick={() => handleSelectAll()}
                    checked={
                      selectedTab === "Clients"
                        ? isAllSelected.client
                        : isAllSelected.provider
                    }
                  />
                  All
                </div>
              </Box>

              <div>
                {selectedTab === "Clients" && (
                  <PlannerClientList
                    clientsListData={filteredClientList}
                    providerListData={providerData}
                    activeTab={false}
                    setSelectedClients={setSelectedClients}
                    allSelectedClients={selectedClients}
                    selectedApplicationTab={selectedApplicationTab}
                    setSelectedProvider={setSelectedProviders}
                    selectedProvider={selectedProviders}
                    bookingData={currentPlan.bookingData}
                    setchangedList={setchangedList}
                    selectedClientIds={selectedClientIds}
                    setSelectedClientIds={setSelectedClientIds}
                    selectedProviderIds={selectedProviderIds}
                    setSelectedProviderIds={setSelectedProviderIds}
                    isAllSelected={isAllSelected}
                    setIsAllSelected={setIsAllSelected}
                    isFilterApplied={isFilterApplied}
                    filteredProviderList={filteredProviderList}
                  />
                )}
                {selectedTab === "Employees" && (
                  <PlannerProviderList
                    providerListData={providerData}
                    filteredProviderData={filteredProviderList}
                    selectedProvider={selectedProviders}
                    setSelectedProviders={setSelectedProviders}
                    setchangedList={setchangedList}
                    isFilterApplied={isFilterApplied}
                    activeTab={false}
                    selectedProviderIds={selectedProviderIds}
                    setSelectedProviderIds={setSelectedProviderIds}
                    setIsAllSelected={setIsAllSelected}
                    isAllSelected={isAllSelected}
                  />
                )}
              </div>
            </Box>
          )}
        </Box>

        <Box
          px={"25px"}
          sx={{ width: drawerOpen ? "80%" : "100%", transition: "width 0.3s" }}
        >
          <div>
            <Box display={"flex"}>
              <ul className="innerTabs">
                <li className="innerTabs__item">
                  <Button
                    onClick={() => setDrawerOpen(!drawerOpen)}
                    sx={{ minWidth: "25px" }}
                  >
                    {drawerOpen ? (
                      <ArrowBackIosIcon color="primary" />
                    ) : (
                      <ArrowForwardIosIcon color="primary" />
                    )}
                  </Button>
                </li>
                <li className="innerTabs__item">
                  <button
                    onClick={() => setSelectedApplicationTabs("Calendar")}
                    className={
                      selectedApplicationTab === "Calendar" ? "active" : ""
                    }
                  >
                    Calendar
                  </button>
                </li>
                <li className="innerTabs__item">
                  <button
                    onClick={() => setSelectedApplicationTabs("Map")}
                    className={selectedApplicationTab === "Map" ? "active" : ""}
                  >
                    Map
                  </button>
                </li>
                <li className="innerTabs__item">
                  <button
                    onClick={() => setSelectedApplicationTabs("Data")}
                    className={
                      selectedApplicationTab === "Data" ? "active" : ""
                    }
                  >
                    Data
                  </button>
                </li>
              </ul>
            </Box>
          </div>
          {selectedApplicationTab === "Calendar" && (
            <>
              {isDataLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "50vh",
                  }}
                >
                  <CircularProgress />
                  <Typography
                    sx={{
                      ml: 2,
                      whiteSpace: "pre-line",
                      maxWidth: "400px",
                      lineHeight: 2,
                      "& > *": {
                        marginBottom: "8px",
                      },
                    }}
                  >
                    {loadingMessage}
                  </Typography>
                </Box>
              ) : (
                <PlanningCalenderNew
                  selectedClients={selectedClients}
                  selectedProviders={selectedProviders}
                  isDataEdited={bookingChange}
                  setIsDataEdited={setBookingChange}
                  drawerOpen={drawerOpen}
                  pendingSchedulesCount={pendingSchedulesCount}
                />
              )}
            </>
          )}
          {selectedApplicationTab === "Data" && (
            <div className="dataTable-Container">
              <DataTable
                addIntoCalendar={addIntoCalendar}
                type="Calendar"
                filteredIds={filteredIds}
              />
            </div>
          )}
          {selectedApplicationTab === "Map" && (
            <PlanningMap
              providerListData={filteredProviderList}
              clientsListData={filteredClientList}
            />
          )}
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default PlanningsDetails;
